type AiAgentDebugPromptOptions = {
  /** The id of the conversation the reply belongs to. */
  csid: string;
  /** The id of the message the AI agent authored. */
  messageId: string;
  /** When the reply was sent. */
  date?: string;
  /** What the agent said was wrong with the reply. */
  note?: string;
};

/**
 * Builds the prompt that opens a debugging session for a single AI agent reply.
 * The agent's own words are fenced and ruled off from the instructions around
 * them. The fence is not escaped, so it holds for prose, not for input that
 * sets out to break it.
 */
export const createAiAgentDebugPrompt = ({
  csid,
  messageId,
  date,
  note,
}: AiAgentDebugPromptOptions): string => {
  const report = note?.trim();

  return [
    [
      `Debug the AI agent reply in Dixa conversation ${csid}.`,
      date
        ? `The reply was sent at ${date} (message id ${messageId}).`
        : `The reply has message id ${messageId}.`,
    ].join('\n'),
    report &&
      `The problem with the reply appears to be:\n<agent_report>\n${report}\n</agent_report>`,
    'Explain why the AI agent answered this way, which knowledge, tools and instructions it used, and what could be improved.',
  ]
    .filter(Boolean)
    .join('\n\n---\n\n');
};
